<template>
	<v-list-item
		three-line
		@click="onClickItemBusca"
	>
		<v-list-item-avatar>
			<v-img
				v-if="item.foto"
				:src="item.foto"
				style="object-fit: cover"
			>
				<template v-slot:placeholder>
					<v-progress-circular indeterminate color="grey"></v-progress-circular>
				</template>
			</v-img>
			<v-icon
				v-else
				v-text="'mdi-account'"
			/>
		</v-list-item-avatar>
		<v-list-item-content>
			<v-list-item-title class="text-wrap">{{ item.nomeCompleto }}</v-list-item-title>
			<v-list-item-subtitle v-if="item.cidade">{{ item.cidade.nomeCompleto }}</v-list-item-subtitle>
			<v-list-item-subtitle>
				{{
					[
						item.cargoDeAdminDaLoja,
						...item.lojas.map(loja => loja.cargoDeAdminDaLoja),
						item.cargoDeAdminDaPotencia,
						item.cargoDeAdminDaSomar ? `${item.cargoDeAdminDaSomar} na Somar` : undefined,
					]
					.filter(cargo=> !!cargo)
					.join(' / ')
				}}
			</v-list-item-subtitle>
			<v-list-item-subtitle>
				{{
					[
						item.loja,
						...item.lojasIrmao,
					].map(loja => loja.nome ).join(' / ')
				}} - {{ item.potencia.nome }}
			</v-list-item-subtitle>
			<v-list-item-subtitle v-if="item.profissao || item.empresa">
				{{
					[
						[
							item.cargo,
							item.empresa
						].filter(oficios=>!!oficios)
						.join(' em '),
						item.profissao,
					]
					.filter(oficios => !!oficios)
					.join(' - ')
				}}
			</v-list-item-subtitle>
			<v-list-item-subtitle v-if="item.hobbie">
				Profissões/Hobbies: {{ item.hobbie }}
			</v-list-item-subtitle>
		</v-list-item-content>
	</v-list-item>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { adicionarBuscaRecente } from '@/shareds/buscasRecentes'
import { ResultadoBusca, ResultadoIrmao } from '../../../../common/types/Busca'
import { useRouter } from '@/composables/router'

const props = defineProps({
	item: { type: Object as PropType<ResultadoIrmao>, required: true },
})

const router = useRouter()

function onClickItemBusca() {
	adicionarBuscaRecente(props.item satisfies ResultadoBusca)
	router.push({
		name: 'detalhar-irmao',
		params: { id: props.item._id },
	})
}
</script>
